"use strict";

import dispatcher from "./../dispatcher";
import {Singleton} from "vwa/flux";
import poiStore from "./pois";

import openedDetailsStore from "./openedDetails";

const displayedDetailsStore = new Singleton();
export default displayedDetailsStore;

window.displayedDetailsStore = displayedDetailsStore;

openedDetailsStore.on('insert', detailsDescriptors => {
	if (!detailsDescriptors[0]) return;
	displayedDetailsStore.set({
		type:		detailsDescriptors[0].type,
		id:			detailsDescriptors[0].id
	});
});

openedDetailsStore.on('remove', detailsDescriptors => {
	const displayedDetails = displayedDetailsStore.get();
	if (!displayedDetails)
		return;
	detailsDescriptors.forEach(detailsDescriptor => {
		if (detailsDescriptor.id == displayedDetails.id)
			displayedDetailsStore.set(null);
	});
});

dispatcher.on("switchDetailsPage", (vehicleId, tabId) => {
	const displayedDetails = displayedDetailsStore.get();
	displayedDetails["id"] = vehicleId;
	displayedDetailsStore.set(displayedDetails);
});

dispatcher.on("logout", () => {
	displayedDetailsStore.set(null);
});


// WEBPACK FOOTER //
// ./src/store/displayedDetails.js